import React from "react";

import { useNavigate } from "react-router-dom";

import { Button } from "components";

const ContextMenu = (props) => {
  const navigate = useNavigate();

  return (
    <div style={{padding: 24, width: '100%'}}>
      <div className={props.className??"flex flex-row gap-5 items-center justify-center sm:justify-start w-full sm:flex-nowrap sm:overflow-scroll  flex-wrap"}>
        <Button
          className="!bg-black-900 !text-white-A700 whitespace-nowrap md:bg-colors2 cursor-pointer flex font-inter h-12 items-center justify-center min-h-[38px] min-w-[189px] rounded-lg text-base text-center md:text-colors1 tracking-[0.50px]"
          color="deep_purple_900_01"
          size="xs"
          shape="round"
          variant="fill"
          onClick={() => navigate("/home")}
        >
          {props?.discovercategories}
        </Button>
        <Button
          className="common-pointer border border-deep_purple-900_01 border-solid cursor-pointer flex font-inter h-12 items-center justify-center min-h-[38px] whitespace-nowrap min-w-[153px] text-base text-center text-deep_purple-900_01 tracking-[0.50px]"
          onClick={() => navigate("/productspage")}
          color="white_A700"
          size="xs"
          shape="round"
          variant="fill"
        >
          {props?.popularproducts}
        </Button>
        <Button
          className="border border-deep_purple-900_01 whitespace-nowrap border-solid cursor-pointer flex font-inter h-12 items-center justify-center min-h-[38px] min-w-[153px] text-base text-center text-deep_purple-900_01 tracking-[0.50px]"
          color="white_A700"
          size="xs"
          shape="round"
          variant="fill"
          onClick={() => navigate("/productspage")}
        >
          {props?.recentproducts}
        </Button>
      </div>
    </div>
  );
};

ContextMenu.defaultProps = {
  discovercategories: "Discover",
  popularproducts: "Popular Products",
  recentproducts: "Recent Products",
  className: undefined,
};

export default ContextMenu;
